export const FormatNegativeNumber = ({ number, numberFormatted }) => {
    if (number < 0) {
        return `(${numberFormatted.replace("-", "")})`;
    }
    return numberFormatted;
};
